import http from '../../utils/http'

// 补票时候获取附近站点
export function getNearStopAndBus(params) {
  return http.post(`/order/getNearStopAndBus`, params)
}

export function getConfig({cityId}) {
  return http.get(`/index/driverParams?cityId=${cityId}`, {})
}
